module.exports = __webpack_public_path__ + "img/new-step9.57f0de1b.jpg";